var subProArray = [];
var isEdit = false;
var bundleId = null;

document.addEventListener("DOMContentLoaded", function () {
  window.onbeforeunload = function (e) {
    const message = "Are you sure you want to leave this page?";
    e.preventDefault();
    e.returnValue = message;
    return message;
  };
});
class bundleElement extends HTMLElement {
  constructor() {
    super();

    document
      .querySelectorAll("[data-bundle-add]")
      .forEach((button) =>
        button.addEventListener("click", this.addProductList.bind(this)),
      );
    document
      .querySelectorAll(".card-close")
      .forEach((button) =>
        button.addEventListener("click", this.removeProductList.bind(this)),
      );
    document
      .querySelectorAll(".bundle-atc")
      .forEach((button) =>
        button.addEventListener("click", this.bundleATC.bind(this)),
      );
    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit"),
    );
    var getURL = window.location.href.split("/").pop();
    var lastPart = getURL.split("?edit=");
    // console.log('eree',lastPart[1]);
    if (lastPart[1] != undefined) {
      bundleId = lastPart[1];
      this.editBundle(bundleId);
      isEdit = true;
    }
  }

  updateEvent() {
    document
      .querySelectorAll("[data-bundle-add-quick]")
      .forEach((button) =>
        button.addEventListener("click", this.addProductList.bind(this)),
      );
  }

  addProductList(event) {
    var varName = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varName");
    var varSku = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varSku");
    var varId = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("value");
    var varTitle = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varTitle");
    let varPrice = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      ?.getAttribute("varPrice");
    var varDesc = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varDesc");
    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit"),
    );
    var singleVariant = null;
    // console.log('color',event.currentTarget.closest('.product-card-wrapper').querySelector('input[name="Color"]:checked'));
    if (
      event.target.closest("button").getAttribute("data-variant-bundle") ==
      "true"
    ) {
      singleVariant = true;
      var varColorName = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varShade");
      var featureImg = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varFeatureImg");
    } else if (
      event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked') == null ||
      event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked') == undefined
    ) {
      var featureImg = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varFeatureImg");
      singleVariant = true;
    } else {
      singleVariant = false;
      var varColor = event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked')
        .getAttribute("data-color");
      var varColorName = event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked')
        .getAttribute("value");
    }

    document.querySelector(".palette-bundle").classList.remove("hidden");
    document.querySelector(".up-down-bundle-open").classList.add("hidden");

    if (subProArray.length < bundleLimit) {
      if (singleVariant == false) {
        subProArray.push({
          varname: varName,
          varsku: varSku,
          varid: varId,
          varcolor: varColor,
          varTitle: varTitle,
          vardesc: varColorName,
          varPrice: varPrice,
          quantity: 1,
        });
      } else if (
        singleVariant == true &&
        event.target.closest("button").getAttribute("data-variant-bundle") ==
          "true"
      ) {
        subProArray.push({
          varname: varName,
          varsku: varSku,
          varid: varId,
          varimg: featureImg,
          varTitle: varTitle,
          vardesc: varColorName,
          varPrice: varPrice,
          quantity: 1,
        });
      } else if (singleVariant == true) {
        subProArray.push({
          varname: varName,
          varsku: varSku,
          varid: varId,
          varimg: featureImg,
          varTitle: varTitle,
          varPrice: varPrice,
          quantity: 1,
        });
      }
    } else if (subProArray.length >= bundleLimit) {
      document.querySelector("[data-warn-popup2]").classList.remove("hidden");
    }

    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-image");
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-color");
        document.querySelector("[data-subtitle-" + index + "]").innerHTML = "";
        document.querySelector("[data-subdesc-" + index + "]").innerHTML = "";
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.add("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette");
      });

    if (subProArray.length > 0) {
      subProArray.forEach(function (val, index) {
        index = index + 1;
        if (val.varcolor == undefined) {
          document.querySelector("[data-subimg-" + index + "]").style.cssText =
            `
                    background-image:url('${val.varimg}'); 
                    background-repeat: no-repeat;
                    `;
        } else if (val.varimg == undefined) {
          document
            .querySelector("[data-subimg-" + index + "]")
            .setAttribute("style", "background-color:" + val.varcolor);
        }

        if (val.vardesc != undefined) {
          document.querySelector("[data-subdesc-" + index + "]").innerHTML =
            val.vardesc;
        }

        document.querySelector("[data-subtitle-" + index + "]").innerHTML =
          val.varTitle;
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.remove("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette");
        // console.log('val',val,'index',index);
      });
      // window.onbeforeunload = function (e) {
      //   var message =
      //     "If you exit the page now you will lose your product selections. Are you sure you want to leave this page?";
      //   return message;
      // };
    }
    if (subProArray.length == bundleLimit) {
      // document.querySelectorAll('.bundle-atc').forEach(button => button.classList.remove('disabled-atc-btn'));
    }
  }

  removeProductList(event) {
    var getIndex = Number(
      event.currentTarget.getAttribute("data-sub-remove") - 1,
    );
    subProArray.splice(getIndex, 1);
    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-image");
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-color");
        document.querySelector("[data-subtitle-" + index + "]").innerHTML = "";
        document.querySelector("[data-subdesc-" + index + "]").innerHTML = "";
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.add("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette");
      });
    if (subProArray.length > 0) {
      subProArray.forEach(function (val, index) {
        index = index + 1;
        if (val.varcolor == undefined) {
          document.querySelector("[data-subimg-" + index + "]").style.cssText =
            `
                    background-image:url('${val.varimg}'); 
                    background-repeat: no-repeat;
                    `;
        } else if (val.varimg == undefined) {
          document
            .querySelector("[data-subimg-" + index + "]")
            .setAttribute("style", "background-color:" + val.varcolor);
          document.querySelector("[data-subdesc-" + index + "]").innerHTML =
            val.vardesc;
        }

        if (val.vardesc != undefined) {
          document.querySelector("[data-subdesc-" + index + "]").innerHTML =
            val.vardesc;
        }
        document.querySelector("[data-subtitle-" + index + "]").innerHTML =
          val.varTitle;
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.remove("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette");
        // console.log('val',val,'index',index);
      });
    }
    // document.querySelectorAll('.bundle-atc').forEach(button => button.classList.add('disabled-atc-btn'));
  }

  bundleATC(event) {
    var varId = event.currentTarget.getAttribute("data-var-id");
    var varName = document
      .querySelector("[data-gift-title]")
      ?.getAttribute("data-gift-title");
    var varSku = document
      .querySelector("[data-gift-sku]")
      ?.getAttribute("data-gift-sku");
    var varGIftVId = document
      .querySelector("[data-gift-varId]")
      ?.getAttribute("data-gift-varId");
    var varGiftPrice = document
      .querySelector("[data-gift-varPrice]")
      ?.getAttribute("data-gift-varPrice");

    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit"),
    );
    var finalArray = [];
    var Items = {};
    var randomNum = Math.floor(Math.random() * 1000000000000);

    if (subProArray.length < bundleLimit) {
      if (
        !document
          .querySelector(".required-product-desk")
          .classList.contains("hidden")
      ) {
        document.querySelector("[data-warn-popup]").classList.remove("hidden");
      } else {
        document
          .querySelector(".required-product-desk")
          .classList.remove("hidden");
        document
          .querySelector(".required-product-mob")
          .classList.remove("hidden");
      }
      return false;
    }

    Items["_variant_ids"] = [];
    Items["_variants"] = [];
    subProArray.forEach((x) => {
      const obj = finalArray.find((o) => Number(o.varid) === Number(x.varid));
      if (obj) {
        // console.log('obj.quantity',obj.quantity,'x.quantity',x.quantity)
        obj.quantity = obj.quantity + x.quantity;
      } else {
        x.quantity = 1;
        finalArray.push(x);
      }
    });
    if (varName != null && varSku != null && varGIftVId != null) {
      finalArray.push({
        varname: varName,
        varsku: varSku,
        quantity: 1,
        varid: varGIftVId,
        varPrice: isNaN(parseFloat(varGiftPrice))
          ? 0
          : parseFloat(varGiftPrice),
      });
    }

    finalArray.forEach(function (i, e) {
      Items[e + 1] = `\n${i.quantity} x ${i.varname} [${i.varsku}]`;
      for (var j = 0; j < i.quantity; j++) {
        Items["_variant_ids"].push(i.varid);
        Items["_variants"].push({
          id: i.varid,
          price: isNaN(parseFloat(i.varPrice)) ? 0 : parseFloat(i.varPrice),
        });
      }

      if (finalArray.length == e + 1) {
        if (isEdit == false) {
          Items["_bundleId"] = randomNum;
        } else {
          Items["_bundleId"] = bundleId;
        }
      }
    });

    window.PAPBundle = { ...Items };
    Items["_variant_ids"] = Items["_variant_ids"].join(",");
    Items["_variants"] = JSON.stringify(Items["_variants"]);

    if (isEdit == false) {
      localStorage.setItem(randomNum, JSON.stringify(subProArray));
    } else if (isEdit == true) {
      localStorage.setItem(bundleId, JSON.stringify(subProArray));
    }

    if (subProArray.length == bundleLimit) {
      window.onbeforeunload = null;
      if (isEdit == false) {
        var body = {
          id: parseInt(varId),
          quantity: 1,
          properties: Items,
        };

        const result = fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        }).then((response) => {
          document
            .querySelector("[data-success-popup]")
            .classList.remove("hidden");
        });
      } else if (isEdit == true) {
        fetch("/cart.json", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((data) => {
          let res = data.json();
          res.then((result) => {
            result.items.forEach(function (items, e) {
              if (
                items.properties["_bundleId"] != undefined &&
                items.properties["_bundleId"] == bundleId
              ) {
                var itemKey = items.key;
                var quantity = items.quantity;
                var body = {
                  id: itemKey,
                  quantity: quantity,
                  properties: Items,
                };

                fetch("/cart/change.js", {
                  body: JSON.stringify(body),
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "xmlhttprequest",
                  },
                  method: "POST",
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (json) {
                    var getHandle = document
                      .querySelector("[data-collection-handle]")
                      .getAttribute("data-collection-handle");
                    var newURL = "/collections/" + getHandle;
                    window.history.pushState(
                      "object or string",
                      "Title",
                      newURL,
                    );
                    document
                      .querySelector("[data-success-popup]")
                      .classList.remove("hidden");
                  })
                  .catch(function (err) {
                    console.error(err);
                  });
              }
            });
          });
        });
      }
    }
  }

  editBundle(getId) {
    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit"),
    );
    subProArray = JSON.parse(localStorage.getItem(getId));
    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-image");
        document
          .querySelector("[data-subimg-" + index + "]")
          .style.removeProperty("background-color");
        document.querySelector("[data-subtitle-" + index + "]").innerHTML = "";
        document.querySelector("[data-subdesc-" + index + "]").innerHTML = "";
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.add("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette");
      });

    if (subProArray.length > 0) {
      subProArray.forEach(function (val, index) {
        index = index + 1;
        if (val.varcolor == undefined) {
          document.querySelector("[data-subimg-" + index + "]").style.cssText =
            `
                    background-image:url('${val.varimg}'); 
                    background-repeat: no-repeat;
                    `;
        } else if (val.varimg == undefined) {
          document
            .querySelector("[data-subimg-" + index + "]")
            .setAttribute("style", "background-color:" + val.varcolor);
          document.querySelector("[data-subdesc-" + index + "]").innerHTML =
            val.vardesc;
        }
        document.querySelector("[data-subtitle-" + index + "]").innerHTML =
          val.varTitle;
        document
          .querySelector('[data-sub-remove="' + index + '"]')
          .classList.remove("hidden");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.remove("card-palette-dot");
        document
          .querySelector("[data-border-" + index + "]")
          .classList.add("card-palette");
        // console.log('val',val,'index',index);
      });
    }
    if (subProArray.length == bundleLimit) {
      // document.querySelectorAll('.bundle-atc').forEach(button => button.classList.remove('disabled-atc-btn'));
    }
    document.querySelector(".palette-bundle").classList.remove("hidden");
    document.querySelector(".up-down-bundle-open").classList.add("hidden");
  }
}
customElements.define("bundle-element", bundleElement);
